import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";
import "@fontsource/source-sans-3/400.css";
import "@fontsource/source-sans-3/500.css";
import "@fontsource/source-sans-3/600.css";
import "@fontsource/source-sans-3/700.css";

import "@/index.css";
// Initialisation i18n en side-effect AVANT le rendu : tout composant
// consommant `t()` (y compris le fallback d'AppErrorBoundary) dispose des
// traductions dès le premier paint.
import "@/app/i18n";

import App from "@/app/App";
import { AppErrorBoundary } from "@/core/components/shared";
import { NoTranslateShell } from "@/core/components/shared";
import { patchDomNodeMutations } from "@/core/utils/func/patch-dom-remove-child";
import React from "react";
import ReactDOM from "react-dom/client";

// Anti-crash removeChild/insertBefore causé par la traduction automatique
// Chrome/Edge et les extensions (Grammarly…) — voir skill projet dédié.
patchDomNodeMutations();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {/* AppErrorBoundary est rendu après l'init i18n ci-dessus (import de
        module exécuté avant createRoot) : son fallback est traduit. */}
    <AppErrorBoundary>
      <NoTranslateShell>
        <App />
      </NoTranslateShell>
    </AppErrorBoundary>
  </React.StrictMode>
);
